// Code snippet from https://dev.to/goenning/how-to-retry-when-react-lazy-fails-mb5
export const retry = (fn, retriesLeft = 5, interval = 1000) => {
    return new Promise((resolve, reject) => {
      fn()
        .then(resolve)
        .catch((error) => {
          setTimeout(() => {
            if (retriesLeft === 1) {
              reject(error)
              return
            }
            retry(fn, retriesLeft - 1, interval).then(resolve, reject)
          }, interval)
        })
    })
  }
